import * as shippingInWarehouseApi from "../../backend/old-version-shipping-in-warehouseApi.js";
const state = {
  headers: [
    {
      title: "№ поставки",
      sortable: false,
      rotate: true,
      name: "shippingNumber",
      dataPath: "Shipping.Number",
      type: "number",
    },
    {
      title: "№ складской",
      sortable: false,
      rotate: true,
      name: "stockNumber",
      dataPath: "StockNumber",
      editor: "TEXT",
    },
    {
      title: "Склад",
      sortable: false,
      rotate: true,
      name: "warehouse",
      valueFn(item) {
        return item.Shipping
          ? item.Shipping.Warehouse
            ? item.Shipping.Warehouse.Title
            : ""
          : "";
      },
    },
    {
      title: "Клиент",
      sortable: false,
      name: "client",
      valueFn(item) {
        return item.Shipping
          ? item.Shipping.Client
            ? item.Shipping.Client.Title
            : ""
          : "";
      },
    },
    {
      title: "Клиент по документам",
      sortable: false,
      name: "clientAlias",
      dataPath: "Shipping.ClientAlias",
    },
    {
      title: "Индекс",
      sortable: false,
      name: "postcode",
      dataPath: "Shipping.Postcode",
    },
    {
      title: "Продавец",
      sortable: false,
      name: "sender",
      valueFn(item) {
        return item.Shipping
          ? item.Shipping.Sender
            ? item.Shipping.Sender.Title
            : ""
          : "";
      },
    },
    {
      title: "Статус",
      sortable: false,
      name: "state",
      editor: "ENUM",
      dataPath: "State",
      width: "75",
    },
    {
      title: "Номер маршрута",
      sortable: false,
      name: "routeNumber",
      valueFn(item) {
        return item.Route ? item.Route.Number : "";
      },
    },
    {
      title: "Метки",
      sortable: false,
      name: "lable",
      children: [
        {
          title: "Вся партия?",
          sortable: false,
          rotate: true,
          name: "isFullBatch",
          dataPath: "IsFullBatch",
          editor: "REF",
        },
        {
          title: "Invoice",
          sortable: false,
          rotate: true,
          name: "invoice",
          dataPath: "Shipping.Invoice",
          editor: "REF",
        },
        {
          title: "Ex",
          sortable: false,
          rotate: true,
          name: "shippingEx",
          dataPath: "Shipping.Ex",
          editor: "LABEL",
        },
        {
          title: "Повреждения",
          sortable: false,
          rotate: true,
          name: "damage",
          dataPath: "Shipping.Damage",
          editor: "REF",
        },
        {
          title: "Особое внимание",
          sortable: false,
          rotate: true,
          name: "attention",
          dataPath: "Shipping.Attention",
          editor: "REF",
        },
        {
          title: "Негабарит",
          sortable: false,
          rotate: true,
          name: "oversized",
          dataPath: "Shipping.Oversized",
          editor: "REF",
        },
        {
          title: "Хрупкое",
          sortable: false,
          rotate: true,
          name: "fragile",
          dataPath: "Shipping.Fragile",
          editor: "REF",
        },
      ],
    },
    {
      title: "Метка Способ упаковки",
      sortable: false,
      name: "packingMethod",
      children: [
        {
          title: "Способ упаковки: приход",
          sortable: false,
          name: "packingMethodIn",
          dataPath: "PackingMethodIn",
          editor: "REF",
        },
        {
          title: "Способ упаковки: отгрузка",
          sortable: false,
          name: "packingMethodOut",
          dataPath: "PackingMethodOut",
          editor: "REF",
        },
      ],
    },
    {
      title: "Дата прихода",
      sortable: false,
      name: "arrivalDate",
      children: [
        {
          title: "План ",
          sortable: false,
          name: "arrivalDatePlan",
          dataPath: "ArrivalDatePlan",
          editor: "DATE",
          width: "100",
        },
        {
          title: "Факт",
          sortable: false,
          name: "arrivalDateFact",
          dataPath: "ArrivalDateFact",
          editor: "DATE",
          width: "100",
        },
      ],
    },
    {
      title: "Дата отгрузки",
      sortable: false,
      name: "unloadingDate",
      children: [
        {
          title: "План ",
          sortable: false,
          name: "arriveToUnloadingPlaceDate",
          valueFn(item) {
            return item.Route
              ? item.Route.ArriveToUnloadingPlaceDate
                ? item.Route.ArriveToUnloadingPlaceDate
                : ""
              : "";
          },
          type: "date",
        },
        {
          title: "Факт ",
          sortable: false,
          name: "dateOfShipmentFact",
          dataPath: "DateOfShipmentFact",
          editor: "DATE",
          width: "100",
        },
      ],
    },
    {
      title: "Объем",
      sortable: false,
      name: "volume",
      children: [
        {
          title: "План",
          sortable: false,
          name: "volumePlan",
          type: "fixedNumber",
          valueFn(item) {
            return item.GoodsDetails
              ? item.GoodsDetails.TotalVolume
              : item.Shipping.Volume;
          },
        },
        {
          title: "Приход",
          sortable: false,
          name: "volumeIn",
          dataPath: "VolumeIn",
          editor: "DECIMAL",
        },
        {
          title: "Отгрузка в машину",
          sortable: false,
          name: "volumeInCar",
          dataPath: "VolumeInCar",
          editor: "DECIMAL",
        },
      ],
    },
    {
      title: "Вес",
      sortable: false,
      name: "weight",
      children: [
        {
          title: "План",
          sortable: false,
          name: "weightPlan",
          type: "fixedNumber",
          valueFn(item) {
            return item.GoodsDetails
              ? item.GoodsDetails.TotalWeightBrutto
              : item.Shipping.Weight;
          },
        },
        {
          title: "Приход",
          sortable: false,
          name: "weightIn",
          dataPath: "WeightIn",
          editor: "DECIMAL",
        },
        {
          title: "Отгрузка в машину",
          sortable: false,
          name: "weightInCar",
          dataPath: "WeightInCar",
          editor: "DECIMAL",
        },
      ],
    },
    {
      title: "Количество",
      sortable: false,
      name: "quantity",
      children: [
        {
          title: "План",
          sortable: false,
          name: "cargoPlaces",
          valueFn(item) {
            return item.GoodsDetails
              ? item.GoodsDetails.TotalCargoPlaces
              : item.Shipping.CargoPlaces;
          },
        },
        {
          title: "Приход",
          sortable: false,
          name: "quantityIn",
          dataPath: "QuantityIn",
          editor: "TEXT",
        },
        {
          title: "Отгрузка",
          sortable: false,
          name: "quantityOut",
          dataPath: "QuantityOut",
          editor: "TEXT",
        },
      ],
    },
    {
      title: "Размеры",
      sortable: false,
      name: "sizes",
      children: [
        {
          title: "План",
          sortable: false,
          name: "cargoSizes",
          valueFn(item) {
            return item.GoodsDetails
              ? item.GoodsDetails.TotalCargoSizes
              : item.Shipping.CargoComment;
          },
        },
        {
          title: "Приход",
          sortable: false,
          name: "sizeIn",
          dataPath: "SizeIn",
          editor: "TEXT",
        },
        {
          title: "Отгрузка",
          sortable: false,
          name: "sizeOut",
          dataPath: "SizeOut",
          editor: "TEXT",
        },
      ],
    },
    {
      title: "Комментарии",
      sortable: false,
      rotate: true,
      name: "comments",
      dataPath: "Comments",
      editor: "TEXT",
    },
    //{ title: "Документы", sortable: false, rotate: true, name: "Attachments" },
  ],
  items: [],
  totalItems: 0,
  loading: false,
  columnsSetting: null,
  savedSettings: [],
  selectedValue: null,
  selectedRow: null,
  columns: [],
};
const getters = {
  headers: state => {
    return state.headers;
  },
  items: state => {
    return state.items;
  },
  totalItems: state => {
    return state.totalItems;
  },
  loading: state => {
    return state.loading;
  },
  columnsSetting(state) {
    return state.columnsSetting;
  },
  savedSettings(state) {
    return state.savedSettings;
  },
  selectedValue(state) {
    return state.selectedValue;
  },
  selectedRow(state) {
    return state.selectedRow;
  },
  columns(state) {
    return state.columns;
  },
};
const mutations = {
  setItems(state, value) {
    state.items = value;
  },
  setTotalItems(state, value) {
    state.totalItems = value;
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setColumnsSetting(state, columnsSetting) {
    state.columnsSetting = columnsSetting;
  },
  setSavedSettings(state, savedSettings) {
    state.savedSettings = savedSettings;
  },
  setSelectedValue(state, selectedValue) {
    state.selectedValue = selectedValue;
  },
  setSelectedRow(state, selectedRow) {
    state.selectedRow = selectedRow;
  },
  setColumns(state, columns) {
    state.columns = columns;
  },
};

const actions = {
  async getData({ commit, getters }, value) {
    commit("setLoading", true);
    const res = await shippingInWarehouseApi.getWarehouseDetails(
      value.page,
      value.rowsPerPage,
    );
    const columns = [];
    getters.headers.map(column => {
      if (column.children) {
        column.children.map(col => {
          return columns.push(col);
        });
      } else {
        return columns.push(column);
      }
    });
    const items = res.data.Result.map(i => {
      const item = { id: i.Id, shippingId: i.Shipping.Id };
      columns.forEach(c => {
        if (c.dataPath) {
          const dataPathSegments = c.dataPath.split(".");
          let value = i;
          dataPathSegments.forEach(s => (value ? (value = value[s]) : ""));
          item[c.name] = value;
        } else if (c.valueFn) {
          item[c.name] = c.valueFn(i);
        } else {
          if (Object.prototype.hasOwnProperty.call(i, c.name)) {
            item[c.name] = i[c.name];
          } else if (Object.prototype.hasOwnProperty.call(i, capitalizeFirstLetter(c.name))) {
            item[c.name] = i[capitalizeFirstLetter(c.name)];
          }
        }
      });
      return item;
    });
    commit("setLoading", false);
    commit("setItems", items);
    commit("setTotalItems", res.data.TotalItems);

    function capitalizeFirstLetter(src) {
      if (!src) {
        return;
      }
      return src.charAt(0).toUpperCase() + src.slice(1);
    }
  },

  async save({ commit, dispatch }, item) {
    commit("setSelectedValue", null);

    commit("setLoading", true);

    const newItem = {
      StockNumber: item.stockNumber,
      IsFullBatch: item.isFullBatch,
      VolumeIn: item.volumeIn,
      VolumeInCar: item.volumeInCar,
      WeightIn: item.weightIn,
      WeightInCar: item.weightInCar,
      QuantityIn: item.quantityIn,
      QuantityOut: item.quantityOut,
      SizeIn: item.sizeIn,
      SizeOut: item.sizeOut,
      Comments: item.comments,
      ArrivalDatePlan: item.arrivalDatePlan,
      ArrivalDateFact: item.arrivalDateFact,
      PackingMethodIn: item.packingMethodIn,
      PackingMethodOut: item.packingMethodOut,
      DateOfShipmentFact: item.dateOfShipmentFact,
      StateId: item.state,
    };

    const res = await shippingInWarehouseApi.putWarehouseDetails(
      item.id,
      newItem,
    );
    if (typeof res.data === "string" && res.data.length > 0) {
      this.showInfo(res.data);
    }
    commit("setLoading", false);
    dispatch("closeDialog");
    commit("setSelectedRow", null);
  },
  async saveShippingLabel({ commit, dispatch }, value) {
    commit("setSelectedValue", null);
    commit("setLoading", true);

    await shippingInWarehouseApi.updateShippingLable(
      value.shippingId,
      value.label.name,
      value.label.value,
    );
    commit("setLoading", false);
    dispatch("closeDialog");
  },
  openDialog({ commit }, item) {
    commit("setSelectedValue", item.value);
    commit("setSelectedRow", item.rowIndex);
  },
  closeDialog({ commit }) {
    commit("setSelectedValue", null);
    commit("setSelectedRow", null);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
